// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("fonts/source-sans-pro-v13-latin-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("fonts/source-sans-pro-v13-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("fonts/source-sans-pro-v13-latin-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("fonts/source-sans-pro-v13-latin-regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("fonts/source-sans-pro-v13-latin-regular.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("fonts/source-sans-pro-v13-latin-italic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("fonts/source-sans-pro-v13-latin-italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("fonts/source-sans-pro-v13-latin-italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("fonts/source-sans-pro-v13-latin-italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("fonts/source-sans-pro-v13-latin-italic.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("fonts/source-sans-pro-v13-latin-700.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("fonts/source-sans-pro-v13-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("fonts/source-sans-pro-v13-latin-700.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("fonts/source-sans-pro-v13-latin-700.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("fonts/source-sans-pro-v13-latin-700.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("fonts/source-sans-pro-v13-latin-700italic.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("fonts/source-sans-pro-v13-latin-700italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("fonts/source-sans-pro-v13-latin-700italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("fonts/source-sans-pro-v13-latin-700italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("fonts/source-sans-pro-v13-latin-700italic.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#SourceSansPro" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "#SourceSansPro" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#SourceSansPro" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#SourceSansPro" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* source-sans-pro-regular - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* IE9 Compat Modes */
  src: local('Source Sans Pro Regular'), local('SourceSansPro-Regular'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___})
      format('embedded-opentype'),
    /* IE6-IE8 */ url(${___CSS_LOADER_URL_REPLACEMENT_2___})
      format('woff2'),
    /* Super Modern Browsers */
      url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff'),
    /* Modern Browsers */ url(${___CSS_LOADER_URL_REPLACEMENT_4___})
      format('truetype'),
    /* Safari, Android, iOS */
      url(${___CSS_LOADER_URL_REPLACEMENT_5___})
      format('svg'); /* Legacy iOS */
}

/* source-sans-pro-italic - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); /* IE9 Compat Modes */
  src: local('Source Sans Pro Italic'), local('SourceSansPro-Italic'),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___})
      format('embedded-opentype'),
    /* IE6-IE8 */ url(${___CSS_LOADER_URL_REPLACEMENT_8___})
      format('woff2'),
    /* Super Modern Browsers */
      url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff'),
    /* Modern Browsers */ url(${___CSS_LOADER_URL_REPLACEMENT_10___})
      format('truetype'),
    /* Safari, Android, iOS */
      url(${___CSS_LOADER_URL_REPLACEMENT_11___})
      format('svg'); /* Legacy iOS */
}

/* source-sans-pro-700 - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); /* IE9 Compat Modes */
  src: local('Source Sans Pro Bold'), local('SourceSansPro-Bold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_13___})
      format('embedded-opentype'),
    /* IE6-IE8 */ url(${___CSS_LOADER_URL_REPLACEMENT_14___})
      format('woff2'),
    /* Super Modern Browsers */ url(${___CSS_LOADER_URL_REPLACEMENT_15___})
      format('woff'),
    /* Modern Browsers */ url(${___CSS_LOADER_URL_REPLACEMENT_16___})
      format('truetype'),
    /* Safari, Android, iOS */
      url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format('svg'); /* Legacy iOS */
}

/* source-sans-pro-700italic - latin */
@font-face {
  font-family: 'Source Sans Pro';
  font-style: italic;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}); /* IE9 Compat Modes */
  src: local('Source Sans Pro Bold Italic'), local('SourceSansPro-BoldItalic'),
    url(${___CSS_LOADER_URL_REPLACEMENT_19___})
      format('embedded-opentype'),
    /* IE6-IE8 */ url(${___CSS_LOADER_URL_REPLACEMENT_20___})
      format('woff2'),
    /* Super Modern Browsers */
      url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format('woff'),
    /* Modern Browsers */ url(${___CSS_LOADER_URL_REPLACEMENT_22___})
      format('truetype'),
    /* Safari, Android, iOS */
      url(${___CSS_LOADER_URL_REPLACEMENT_23___})
      format('svg'); /* Legacy iOS */
}

html {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  width: 100%;
  font-family: 'Source Sans Pro';
  background-image: radial-gradient(
    farthest-side at 95% 90%,
    #f8f8f8 0%,
    #d1d1d1 100%
  );
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

body {
  margin: 0;
  padding: 0;
  min-width: 100%;
  min-height: 100vh;
  font-size: 16px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin-top: 0;
}

h2,
h3 {
  font-weight: normal;
}

p {
  margin: 0 0 1.4em 0;
}

.title-case {
  text-transform: capitalize;
}

td {
  overflow-wrap: break-word;
  max-width: 760px;
}

.credentialRowTd {
  padding: 0 6px;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,4CAAuD,EAAE,qBAAqB;EAC9E;;;;;;;;;;;mBAWiB,EAAE,eAAe;AACpC;;AAEA,mCAAmC;AACnC;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,4CAAsD,EAAE,qBAAqB;EAC7E;;;;;;;;;;;mBAWiB,EAAE,eAAe;AACpC;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,6CAAmD,EAAE,qBAAqB;EAC1E;;;;;;;;;;4DAU8E,EAAE,eAAe;AACjG;;AAEA,sCAAsC;AACtC;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,6CAAyD,EAAE,qBAAqB;EAChF;;;;;;;;;;;mBAWiB,EAAE,eAAe;AACpC;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B;;;;GAIC;AACH;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;EAME,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["/* source-sans-pro-regular - latin */\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 400;\n  src: url('fonts/source-sans-pro-v13-latin-regular.eot'); /* IE9 Compat Modes */\n  src: local('Source Sans Pro Regular'), local('SourceSansPro-Regular'),\n    url('fonts/source-sans-pro-v13-latin-regular.eot?#iefix')\n      format('embedded-opentype'),\n    /* IE6-IE8 */ url('fonts/source-sans-pro-v13-latin-regular.woff2')\n      format('woff2'),\n    /* Super Modern Browsers */\n      url('fonts/source-sans-pro-v13-latin-regular.woff') format('woff'),\n    /* Modern Browsers */ url('fonts/source-sans-pro-v13-latin-regular.ttf')\n      format('truetype'),\n    /* Safari, Android, iOS */\n      url('fonts/source-sans-pro-v13-latin-regular.svg#SourceSansPro')\n      format('svg'); /* Legacy iOS */\n}\n\n/* source-sans-pro-italic - latin */\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: italic;\n  font-weight: 400;\n  src: url('fonts/source-sans-pro-v13-latin-italic.eot'); /* IE9 Compat Modes */\n  src: local('Source Sans Pro Italic'), local('SourceSansPro-Italic'),\n    url('fonts/source-sans-pro-v13-latin-italic.eot?#iefix')\n      format('embedded-opentype'),\n    /* IE6-IE8 */ url('fonts/source-sans-pro-v13-latin-italic.woff2')\n      format('woff2'),\n    /* Super Modern Browsers */\n      url('fonts/source-sans-pro-v13-latin-italic.woff') format('woff'),\n    /* Modern Browsers */ url('fonts/source-sans-pro-v13-latin-italic.ttf')\n      format('truetype'),\n    /* Safari, Android, iOS */\n      url('fonts/source-sans-pro-v13-latin-italic.svg#SourceSansPro')\n      format('svg'); /* Legacy iOS */\n}\n\n/* source-sans-pro-700 - latin */\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: normal;\n  font-weight: 700;\n  src: url('fonts/source-sans-pro-v13-latin-700.eot'); /* IE9 Compat Modes */\n  src: local('Source Sans Pro Bold'), local('SourceSansPro-Bold'),\n    url('fonts/source-sans-pro-v13-latin-700.eot?#iefix')\n      format('embedded-opentype'),\n    /* IE6-IE8 */ url('fonts/source-sans-pro-v13-latin-700.woff2')\n      format('woff2'),\n    /* Super Modern Browsers */ url('fonts/source-sans-pro-v13-latin-700.woff')\n      format('woff'),\n    /* Modern Browsers */ url('fonts/source-sans-pro-v13-latin-700.ttf')\n      format('truetype'),\n    /* Safari, Android, iOS */\n      url('fonts/source-sans-pro-v13-latin-700.svg#SourceSansPro') format('svg'); /* Legacy iOS */\n}\n\n/* source-sans-pro-700italic - latin */\n@font-face {\n  font-family: 'Source Sans Pro';\n  font-style: italic;\n  font-weight: 700;\n  src: url('fonts/source-sans-pro-v13-latin-700italic.eot'); /* IE9 Compat Modes */\n  src: local('Source Sans Pro Bold Italic'), local('SourceSansPro-BoldItalic'),\n    url('fonts/source-sans-pro-v13-latin-700italic.eot?#iefix')\n      format('embedded-opentype'),\n    /* IE6-IE8 */ url('fonts/source-sans-pro-v13-latin-700italic.woff2')\n      format('woff2'),\n    /* Super Modern Browsers */\n      url('fonts/source-sans-pro-v13-latin-700italic.woff') format('woff'),\n    /* Modern Browsers */ url('fonts/source-sans-pro-v13-latin-700italic.ttf')\n      format('truetype'),\n    /* Safari, Android, iOS */\n      url('fonts/source-sans-pro-v13-latin-700italic.svg#SourceSansPro')\n      format('svg'); /* Legacy iOS */\n}\n\nhtml {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  font-family: 'Source Sans Pro';\n  background-image: radial-gradient(\n    farthest-side at 95% 90%,\n    #f8f8f8 0%,\n    #d1d1d1 100%\n  );\n}\n\n*,\n*:before,\n*:after {\n  box-sizing: inherit;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  min-width: 100%;\n  min-height: 100vh;\n  font-size: 16px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin-top: 0;\n}\n\nh2,\nh3 {\n  font-weight: normal;\n}\n\np {\n  margin: 0 0 1.4em 0;\n}\n\n.title-case {\n  text-transform: capitalize;\n}\n\ntd {\n  overflow-wrap: break-word;\n  max-width: 760px;\n}\n\n.credentialRowTd {\n  padding: 0 6px;\n  text-align: left;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
